class ColorSchemeManager {
    static SCHEMES = {
        'light' : 'light',
        'dark'  : 'dark',
        'system': 'system'
    };
    schemes = ColorSchemeManager.SCHEMES;
    attr_name = 'data-color-scheme';
    storage_name = 'color-scheme';

    /**
     * @param {Object?} options
     * */
    constructor(options = {}) {
        const that = this;

        that.active_scheme = ColorSchemeManager.SCHEMES.light;
        that.animate_timer = 0;

        that.#init();
    }

    #init() {
        const that = this;

        that.$html = $(document.documentElement);

        const scheme = that.getScheme();
        if (scheme !== that.active_scheme) {
            that.setScheme(scheme);
        } else {
            that.#render(scheme);
        }
    }

    /**
     * @return {String}
     * */
    getScheme() {
        const that = this;

        let result = that.active_scheme;

        const scheme_storage = localStorage.getItem(that.storage_name);
        if (scheme_storage && that.schemes[scheme_storage]) {
            result = scheme_storage;
        }

        return result;
    }

    /**
     * @param {String} scheme
     * */
    setScheme(scheme) {
        const that = this;

        if (scheme !== that.active_scheme) {
            that.active_scheme = scheme;
            localStorage.setItem(that.storage_name, scheme);    
            that.#render(scheme);
        }
    }

    /**
     * @param {String?} scheme
     * @return {Boolean}
     * */
    isDark(scheme) {
        const that = this;

        scheme = (scheme || that.active_scheme);

        let result = false;

        switch (scheme) {
            case that.schemes.dark:
                result = true;
                break;

            case that.schemes.system:
                result = isSystemDark();
                break;

            default:
                break;
        }

        return result;

        function isSystemDark() {
            return !!(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);
        }
    }

    /**
     * @param {String} scheme
     * */
    #render(scheme) {
        const that = this;

        const animate_class = 'animated-color-scheme-change',
              animate_time = 300;

        const is_dark = that.isDark(scheme);
        if (is_dark) {
            scheme = that.schemes.dark;
        } else {
            scheme = that.schemes.light;
        }

        clearTimeout(that.animate_timer);

        that.$html
            .addClass(animate_class)
            .attr(that.attr_name, scheme);

        that.animate_timer = setTimeout(function() {
            that.$html.removeClass(animate_class);
        }, animate_time);
    }
}